import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import ItemList from './ItemList';
import { ItemInterface } from '../../../ui/List/Checkbox';

import { CompositionsInterface, PrescriptionItemInterface } from '../../../../interfaces/prescription';

import { toggleItem as toggle } from '../../../../store/prescription/actions';
import { AppState } from '../../../../store';

interface StateProps {
  prescriptionItems: PrescriptionItemInterface[];
}

interface DispatchProps {
  toggleItem: Function;
}

type Props = StateProps & DispatchProps;

const ItemListContainer: React.FC<Props> = ({ prescriptionItems, toggleItem }: Props) => {
  const [items, setItems] = useState<Array<ItemInterface>>([]);

  const transformItems = (
    list: PrescriptionItemInterface[],
  ): {
    id: number;
    title: string;
    quantity: number;
    unit: string;
    description: string;
    checked: boolean;
    dispensedLabel: string;
    blockedLabel: string;
    compositions: CompositionsInterface;
  }[] => {
    return list.map((item) => {
      return {
        id: item.id,
        title: item.name,
        quantity: item.original_quantity,
        unit: item.unit,
        description: item.dosage,
        checked: item.checked,
        blockedLabel: item.blocked ? 'bloqueio temporário' : '',
        dispensedLabel: item.dispensed ? 'dispensado' : '',
        compositions: item.compositions,
      };
    });
  };

  useEffect(() => {
    setItems(transformItems(prescriptionItems));
  }, [prescriptionItems]);

  const onClickItem = (clicked: ItemInterface): void => {
    setItems(transformItems(toggleItem(clicked.id)));
  };

  return <ItemList items={items} onClickItem={onClickItem} />;
};

const mapStateToProps = ({ prescription }: AppState): StateProps => ({
  prescriptionItems: prescription.prescription.items,
});

const mapDispatchToProps = {
  toggleItem: toggle,
};

export default connect(mapStateToProps, mapDispatchToProps)(ItemListContainer);
